var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.2 17.4",
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "garbage",
    d: "M13.7,5.3H3.4c0,0.1,0-0.5,0.7,10.6c0,0.6,0.5,1,1.1,1.1h6.6c0.6,0,1.1-0.5,1.1-1.1 C13.8,4.8,13.7,5.4,13.7,5.3z M6.6,14.9c-0.3,0-0.5-0.2-0.6-0.5l-0.5-6c0-0.3,0.2-0.5,0.4-0.6c0.3,0,0.5,0.2,0.6,0.4c0,0,0,0,0,0 l0.5,6C7.1,14.6,6.8,14.9,6.6,14.9C6.6,14.9,6.6,14.9,6.6,14.9L6.6,14.9z M9.1,14.4c0,0.3-0.3,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5 v-6c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5c0,0,0,0,0,0V14.4z M11.7,8.5l-0.5,6c0,0.3-0.3,0.5-0.6,0.4c-0.3,0-0.5-0.3-0.4-0.5 l0.5-6c0-0.3,0.3-0.5,0.5-0.5S11.7,8.1,11.7,8.5C11.7,8.4,11.7,8.5,11.7,8.5z M13.9,2.2h-2.5c0-0.1,0,0,0-0.7c0-0.6-0.5-1.1-1.1-1.1 H6.9c-0.6,0-1.1,0.5-1.1,1.1c0,0.7,0,0.6,0,0.7H3.2c-0.6,0-1.1,0.5-1.1,1.1c0,0.9,0,0.9,0,0.9h13c0-0.1,0,0,0-0.9 C15.1,2.7,14.6,2.2,13.9,2.2z M10.4,2.1C10.4,2.2,10.4,2.2,10.4,2.1L6.9,2.2c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0V1.5c0,0,0-0.1,0.1-0.1 l0,0h3.4c0,0,0.1,0,0.1,0.1L10.4,2.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.26056f13.svg";
export { ForwardRef as ReactComponent };